import styled from 'styled-components';

export const SectionDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;
`;

export const InlineImgIcon = styled.img`
  padding: 0;
  margin: 0;
  width: 1rem;
  height: 1rem;
`;
